// A patient signs in to ONE clinic, the one the page's address names (/login/<db>). The clinic's links carry its page
// (the welcome and password emails); a patient who reaches the portal without one (a bookmark, a new device) chooses
// their clinic from the list on the portal's own page, and a patient of two clinics changes between them ("Change
// clinic": /login?change=1) — Rafael, 2026-10-25. The list chooses nothing for the patient: a list that came with its
// first clinic chosen told patients who did not change it that their password was wrong (2026-10-24).
//
// The clinic this device last signed in to is remembered (a convenience of this browser, nothing more), so a page that
// sends the patient back to sign in sends them to their clinic's page, unless they asked to change it.

const KEY = "blh.patientPortal.clinic";
const CLINIC = /^[a-z0-9][a-z0-9_-]{0,62}$/i;

/** After signing in: this device's clinic. */
export function rememberClinic(db) {
  if (!CLINIC.test(String(db || ""))) return;
  try {
    window.localStorage.setItem(KEY, db);
  } catch {
    // Storage refused (a private window): the patient opens their clinic's link again next time.
  }
}

/** The clinic this device last signed in to, or null. */
export function rememberedClinic() {
  try {
    const db = window.localStorage.getItem(KEY);
    return CLINIC.test(String(db || "")) ? db : null;
  } catch {
    return null;
  }
}

/** The portal's own page, to choose another clinic: it does not send the patient back to the remembered one. */
export const CHANGE_CLINIC_PATH = "/login?change=1";

/** Whether the portal's own page was opened to change clinic. */
export const isChangingClinic = (search) => new URLSearchParams(search || "").has("change");

/** The sign-in page: the clinic's own (the one given, else this device's), or the portal's, where it is chosen. */
export function loginPath(db = rememberedClinic()) {
  return CLINIC.test(String(db || "")) ? `/login/${encodeURIComponent(db)}` : "/login";
}
